import {Select, MenuItem, FormControl, InputLabel, Box} from '@material-ui/core';

export default function Payment({details, selected, setSelected, label}) {

  return (
    <div>
      <Box my={2}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>
            {label}
          </InputLabel>
          <Select
            labelId="label-selected"
            onChange={(event) => setSelected(event.target.value)}
            value={selected}
            label={label}
            fullWidth
          >
            {details.map((detail =>
              <MenuItem key={detail.id} value={detail.id}>
                {detail.dataName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </div>
  );
}
